import { Card, CardBody, CardHeader } from "reactstrap";
import { CultivoTable } from "../components/cultivo.table";
import { useState } from "react";
import { AgregarCultivo } from "../components/agregar";
import { useCultivo } from "../hooks/useCultivo";
import { EditarCultivo } from "../components/editar";

export const CultivoIndex = () => {
  const { cultivo, getCultivo } = useCultivo();
  const [isAdding, setIsAdding] = useState(false);
  const [selectedCultivo, setSelectedCultivo] = useState(null);

  const onAddingClick = () => {
    setSelectedCultivo(null);
    setIsAdding(!isAdding);
  };

  const onEditingClick = (id_cultivo) => {
    setSelectedCultivo(id_cultivo);
    setIsAdding(false);
  };

  const onCancel = () => {
    setIsAdding(false);
    setSelectedCultivo(null);
  };

  const onAdded = () => {
    getCultivo();
    setIsAdding(false);
    setSelectedCultivo(null);
  };

  return (
    <Card className="my-2">
      <CardHeader style={{ fontWeight: "bold", textAlign: "center" }}>
        Nuevo cultivo
      </CardHeader>
      <CardBody>
        <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
          <CultivoTable
            onAddingClick={onAddingClick}
            cultivo={cultivo}
            getCultivo={getCultivo}
            onEditingClick={onEditingClick}
          />
          {isAdding && <AgregarCultivo reload={onAdded} />}
          {selectedCultivo && (
            <EditarCultivo
              reload={onAdded}
              id_cultivo={selectedCultivo}
              onCancel={onCancel}
            />
          )}
        </div>
      </CardBody>
    </Card>
  );
};
